import useBrands from "../../explorer/hooks/useBrands";
import { useReduxState } from "../../explorer/redux/hooks";
import { Site } from "../../explorer/types/SpareParts";
import { reduxStoreConfig } from "../configuration/reduxStoreConfig";
import ServiceProvider from "../configuration/ServiceProvider";

const useCurrentSite: () => [Site, (site: Site) => void] = () => {
  const [currentSite, setCurrentSite] = useReduxState<Site>(reduxStoreConfig.sparePartsCurrentSite);
  const brand = useBrands().currentBrandUrl;
  
  const setCurrentSiteService = (currSite: Site) => {
      ServiceProvider.SpareParts.setCurrentSite(brand, currSite)
        .then((result) => {
          setCurrentSite(result);
        })
        .catch((e) => console.error(e));
    };

  return [currentSite, setCurrentSiteService];
};
export default useCurrentSite;
